import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { BffQueryKey } from '../model/BffQueryKey';
import { getCustomer } from '../utils/customer-utils';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { Customer } from './model';

export const useCustomerGet = (): UseQueryResult<Customer> => {
    const authContext = useAuthContext();

    // eslint-disable-next-line @tanstack/query/prefer-query-object-syntax
    return useQuery<Customer, BFFHttpError>({
        queryFn: async (): Promise<Customer> => {
            if (!isServer) await window.sfccSessionCreationPromise;
            return getCustomer(authContext);
        },
        queryKey: [BffQueryKey.CUSTOMER],
        enabled: !isServer,
        refetchOnWindowFocus: false,
    } as UseQueryOptions<Customer, BFFHttpError>);
};
